(function () {
  'use strict';

  const SNAP_COOLDOWN = 1000;
  const TEMPLATE = document.body.dataset.template;

  let isSnapping = false;
  let lastSnapTime = 0;
  let lastScrollY = window.scrollY;
  let scrollDirection = 'down';

  function getSections() {
    let candidates;

    if (TEMPLATE === 'index') {
      candidates = Array.from(document.querySelectorAll('.shopify-section'));
    } else {
      candidates = Array.from(
        document.querySelectorAll('.shopify-section [data-snap]')
      ).map((el) => el.closest('.shopify-section'));
    }

    return candidates.filter((el) => el && el.offsetHeight >= 50);
  }

  function snapToNext(nextSection) {
    const now = Date.now();
    if (isSnapping || now - lastSnapTime < SNAP_COOLDOWN) return;

    isSnapping = true;
    lastSnapTime = now;

    nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

    setTimeout(() => {
      isSnapping = false;
    }, SNAP_COOLDOWN);
  }

  function onScroll() {
    const currentScrollY = window.scrollY;
    scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';
    lastScrollY = currentScrollY;

    if (scrollDirection !== 'down') return;
    if (isSnapping) return;

    const sections = getSections();
    const vh = window.innerHeight;

    sections.forEach((section, idx) => {
      if (idx === sections.length - 1) return;

      const rect = section.getBoundingClientRect();
      const nextSection = sections[idx + 1];
      const nextRect = nextSection.getBoundingClientRect();

      const bigSectionTrigger = section.offsetHeight >= vh
        && rect.bottom <= vh + 30
        && rect.bottom >= vh - 30;

      const smallSectionTrigger = section.offsetHeight < vh
        && nextRect.top <= vh
        && nextRect.top >= vh * 0.75;

      if (bigSectionTrigger || smallSectionTrigger) {
        snapToNext(nextSection);
      }
    });
  }

  if (TEMPLATE === 'index' || TEMPLATE === 'product') {
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();